import { __decorate } from "tslib";
import { SVG_CHEVRON_DOWN_OUTLINED, SVG_CHEVRON_UP_OUTLINED } from '@getgo/chameleon-icons';
import { attr, html, observable, ref, slotted, when } from '@microsoft/fast-element';
import { assertSlotNonNull } from '../common/asserts';
import { ChameleonElementMixin } from '../common/mixin';
import { getHostChildrenFromEvent } from '../common/utils/DomUtil';
import { FoundationElement } from '@microsoft/fast-foundation';
export const squircleButtonTemplate = html `<div
    @click=${(x, { event }) => x.clickHandler(event)}
  >
    <chameleon-button
      ${ref('actionButton')}
      class="action"
      variant="${(x) => x.variant}"
      size="${(x) => x.size}"
      disabled="${(x) => x.disabled}"
      is-loading="${(x) => x.isLoading}"
    >
      <slot ${ref('iconSlot')} class="icon" name="icon"></slot>
    </chameleon-button>
    ${when((x) => x.split, html `<chameleon-popover ${ref('popoverButton')} position="${(x) => x.position}" menu>
        <chameleon-button
          slot="trigger"
          variant="${(x) => x.variant}"
          size="${(x) => x.size}"
          disabled=${(x) => x.disabled || x.isLoading}
        >
          ${when((x) => x.shouldShowChevronBottom(), html `<chameleon-svg>${SVG_CHEVRON_DOWN_OUTLINED}</chameleon-svg>`)}
          ${when((x) => !x.shouldShowChevronBottom(), html `<chameleon-svg>${SVG_CHEVRON_UP_OUTLINED}</chameleon-svg>`)}
        </chameleon-button>
        <div slot="content">
          <slot ${ref('actionsSlot')} ${slotted('slottedActionItems')} name="actions"></slot>
        </div>
      </chameleon-popover>`)}
  </div>
  <span class="label" slot="label">${(x) => x.label}</span>`;
export class SquircleButtonComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.size = 'large';
        this.variant = 'primary';
        this.position = 'top-center';
        this.split = false;
        this.disabled = false;
        this.isLoading = false;
        this.label = '';
        this.popoverChangeHandler = (e) => this.$emit('popoverchange', e.detail, { bubbles: false });
        this.shouldShowChevronBottom = () => {
            if (this.position.includes('bottom')) {
                return true;
            }
            return false;
        };
    }
    slottedActionItemsChanged(_prev, next) {
        var _a;
        if (next.length > 0) {
            (_a = this.actionsSlot) === null || _a === void 0 ? void 0 : _a.appendChild(next[0]);
        }
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.assertForIconSlot();
        (_a = this.popoverButton) === null || _a === void 0 ? void 0 : _a.addEventListener('popoverchange', this.popoverChangeHandler);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.popoverButton) === null || _a === void 0 ? void 0 : _a.removeEventListener('popoverchange', this.popoverChangeHandler);
    }
    clickHandler(e) {
        if (this.actionButton) {
            const childs = getHostChildrenFromEvent(e, this.actionButton);
            if (!childs.length) {
                e.stopImmediatePropagation();
            }
        }
    }
    assertForIconSlot() {
        const iconElement = this.iconSlot.assignedElements()[0];
        if (!iconElement)
            assertSlotNonNull(iconElement, 'SquircleButtonComponent', 'icon');
    }
}
__decorate([
    attr
], SquircleButtonComponent.prototype, "size", void 0);
__decorate([
    attr
], SquircleButtonComponent.prototype, "variant", void 0);
__decorate([
    attr
], SquircleButtonComponent.prototype, "position", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SquircleButtonComponent.prototype, "split", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SquircleButtonComponent.prototype, "disabled", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SquircleButtonComponent.prototype, "isLoading", void 0);
__decorate([
    attr
], SquircleButtonComponent.prototype, "label", void 0);
__decorate([
    observable
], SquircleButtonComponent.prototype, "slottedActionItems", void 0);
